// @ts-ignore
import React from 'react';
import Select from 'react-select'
import './select.scss';

const styles = {
    option: (provided:any, state:any) => ({
        ...provided,
        "&::before": {
            content: state.isSelected ? `'✓'` : '""'
        }
    }),
    singleValue: (provided:any, state:any) => ({
        ...provided,
        "&::before": {
            content: "✓"
        }
    })
}

interface SelectInterface {
    id: string;
    options: any;
    label: string;
    disabled: boolean;
    empty_message: string;
    onChange: any;
    value: any;
}

export class SelectFactory extends React.Component<SelectInterface, any>
{
    render() {
        const { id, options, disabled, empty_message, label, onChange, value } = this.props;
        return <div className={"select_field"}>
            <div className={"select_field_label"}>
                <label
                    htmlFor={id}
                >
                    {this.props.label}
                </label>
            </div>
            <Select
                inputId={id}
                options={options}
                isDisabled={disabled}
                placeholder={"Wybierz"}
                noOptionsMessage={() => { return empty_message; }}
                onChange={ (e) => onChange(e) }
                isClearable={false}
                styles={styles}
                value={value}
            />
        </div>
    }
}
